/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData model module.
 * @module model/LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData
 * @version 1.0
 */
class LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData {
    /**
     * Constructs a new <code>LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData</code>.
     * @alias module:model/LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData
     */
    constructor() { 
        
        LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData} The populated <code>LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('contentNo')) {
                obj['contentNo'] = ApiClient.convertToType(data['contentNo'], 'Number');
            }
            if (data.hasOwnProperty('beforeStoredPower')) {
                obj['beforeStoredPower'] = ApiClient.convertToType(data['beforeStoredPower'], 'Number');
            }
            if (data.hasOwnProperty('afterStoredPower')) {
                obj['afterStoredPower'] = ApiClient.convertToType(data['afterStoredPower'], 'Number');
            }
            if (data.hasOwnProperty('maxStoredPower')) {
                obj['maxStoredPower'] = ApiClient.convertToType(data['maxStoredPower'], 'Number');
            }
            if (data.hasOwnProperty('addedMaxStoredPowerEndAt')) {
                obj['addedMaxStoredPowerEndAt'] = ApiClient.convertToType(data['addedMaxStoredPowerEndAt'], 'Date');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData.prototype['accountNo'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData.prototype['nftUid'] = undefined;

/**
 * @member {Number} contentNo
 */
LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData.prototype['contentNo'] = undefined;

/**
 * @member {Number} beforeStoredPower
 */
LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData.prototype['beforeStoredPower'] = undefined;

/**
 * @member {Number} afterStoredPower
 */
LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData.prototype['afterStoredPower'] = undefined;

/**
 * @member {Number} maxStoredPower
 */
LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData.prototype['maxStoredPower'] = undefined;

/**
 * @member {Date} addedMaxStoredPowerEndAt
 */
LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData.prototype['addedMaxStoredPowerEndAt'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData.prototype['createdAt'] = undefined;






export default LogControllerDtoNftStoredPowersLogListNftStoredPowersLogListData;

